module.exports = __webpack_public_path__ + "img/title-6.a5670679.png";